import type { MedicationActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import type { DeepReadonlyObject } from "rxdb"
import type { AccountMedication } from "src/types"

export function accountMedicationToActivityMedication(accountMedication: DeepReadonlyObject<AccountMedication>): MedicationActivity["medication"] {
  return {
    account_med_id: Number(accountMedication.id),
    med_id: Number(accountMedication.med_id),
    category: accountMedication.med.category ?? "",
    description: accountMedication.med.description ?? "",
    name: accountMedication.med.name ?? "",
    subcategory: accountMedication.med.subcategory ?? "",
    units: accountMedication.units,
  }
}
